const personnelType = {
    FlexibleEmployment:"灵工人员",
    ThirdParty: "第三方",
}
module.exports = {
    personnelType
};